import { useState } from "react";
import { withTheme } from "@material-ui/core";
import ImovelChip from "./ImovelChip";

type ImoveisChipListProps = {
  items: string[];
};

function ImoveisChipList({ items }: ImoveisChipListProps) {
  const [expanded, setExpanded] = useState(false);

  const hasMore = items.length > 2;
  const visibleItems = expanded ? items : items.slice(0, 2);
  const remainingCount = items.length - 2;

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "3px", alignItems: "center" }}>
      {visibleItems.map((item, index) => (
        <ImovelChip key={index} label={item} />
      ))}
      {hasMore && (
        <span
          onClick={() => setExpanded(!expanded)}
          style={{
            textDecoration: "underline",
            cursor: "pointer",
            fontSize: "11px",
            marginLeft: "4px",
          }}
        >
          {expanded ? "fechar" : `+${remainingCount}`}
        </span>
      )}
    </div>
  );
}

export default withTheme(ImoveisChipList);
